import * as Sentry from '@sentry/remix';

import { ensurePixelIsLoaded } from '~/utils/pixels';

// https://developers.facebook.com/docs/meta-pixel/implementation/conversion-tracking/
type StandardEventNames = 'AddToCart' | 'Purchase' | 'PageView' | 'ViewContent';
type CustomEventNames =
  | 'CompleteRegistration'
  | 'NotifyMeSet'
  | 'InitiateCheckout'
  | 'AddPaymentInfo';

type StandardEvent = {
  data?: unknown;
  eventID: string;
  eventName: StandardEventNames;
};

export async function fireEvent({
  eventName,
  eventID,
  data = {}
}: StandardEvent) {
  try {
    await ensurePixelIsLoaded('fbq');

    window.fbq('consent', 'grant');
    window.fbq('track', eventName, data, { eventID });
  } catch (error) {
    Sentry.captureException(error, {
      extra: { message: 'Failed to fire Facebook pixel event' }
    });
  }
}

export async function fireCustomEvent(
  eventName: CustomEventNames,
  data?: unknown
) {
  try {
    await ensurePixelIsLoaded('fbq');

    window.fbq('consent', 'grant');
    window.fbq('trackCustom', eventName, data);
  } catch (error) {
    Sentry.captureException(error, {
      extra: { message: 'Failed to fire Facebook custom pixel event' }
    });
  }
}

export default {
  fireCustomEvent,
  fireEvent
};
